import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { cpfMask } from '../../helper/MaskHelper';

import useStyles from './Style'

import DataItem from './DataItem'

const DadosCandidato = ({ candidato, telefonePrincipal, telefoneAlternativo }) => {
    const classes = useStyles();
    return (
        <div className={classes.section}>
            <Typography className={classes.title}>Dados do Professor</Typography>
            <Grid container spacing={2}>
                <DataItem label="Nome Completo" value={candidato.nome} sm={4} />
                <DataItem label="Nome Social" value={candidato.nomeSocial} sm={4} />
                <DataItem label="CPF" value={cpfMask(candidato.cpf)} sm={4} />
                
                <DataItem label="Data de Nascimento" value={candidato.dataNascimento} />
                <DataItem label="Sexo" value={candidato.sexo} />
                <DataItem label="Raça" value={candidato.raca} />
                
                <DataItem label="E-mail" value={candidato.email} sm={4} />
                <DataItem label="Telefone Principal" value={`${telefonePrincipal.ddd} ${telefonePrincipal.telefone}`} sm={4} />
                <DataItem label="Telefone Alternativo" value={telefoneAlternativo.ddd && telefoneAlternativo.telefone ? `${telefoneAlternativo.ddd} ${telefoneAlternativo.telefone}` : null} sm={4} />
                <br />

                {candidato.necessidadeEspecial && <DataItem label="Deficiência" value={candidato.necessidadeEspecial} sm={4} />}
                {candidato.descricaoOutrasDeficiencias && <DataItem label="Descrição de Deficiência" value={candidato.descricaoOutrasDeficiencias} sm={8} />}

                {candidato.sabatista && <DataItem label="Sabatista" value={candidato.sabatista} sm={4} />}
            </Grid>
        </div>
    );
}

export default DadosCandidato;